import { render } from "./ModalQuizResult.vue?vue&type=template&id=0dd706a0&scoped=true"
import script from "./ModalQuizResult.vue?vue&type=script&lang=js"
export * from "./ModalQuizResult.vue?vue&type=script&lang=js"

import "./ModalQuizResult.vue?vue&type=style&index=0&id=0dd706a0&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd706a0"]])

export default __exports__